import { render, staticRenderFns } from "./anulaciones.vue?vue&type=template&id=1c6ff01f"
import script from "./anulaciones.vue?vue&type=script&lang=js"
export * from "./anulaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports